var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com_3_",
    "data-name": "star-svgrepo-com (3)",
    d: "M7.007,4.386C7.894,2.8,8.337,2,9,2s1.106.8,1.993,2.386l.229.412a2.568,2.568,0,0,0,.574.827,2.393,2.393,0,0,0,.93.315l.445.1c1.722.39,2.583.584,2.787,1.243S15.578,8.628,14.4,10l-.3.355a2.577,2.577,0,0,0-.575.826,2.689,2.689,0,0,0,0,1.022l.046.474c.177,1.831.266,2.747-.27,3.154s-1.342.036-2.954-.706l-.417-.192A2.388,2.388,0,0,0,9,14.617a2.388,2.388,0,0,0-.93.316l-.417.192c-1.612.742-2.418,1.113-2.954.706s-.447-1.323-.27-3.154l.046-.474a2.687,2.687,0,0,0,0-1.022,2.576,2.576,0,0,0-.575-.826L3.6,10C2.422,8.628,1.835,7.942,2.04,7.283S3.106,6.43,4.828,6.04l.445-.1a2.393,2.393,0,0,0,.93-.315A2.568,2.568,0,0,0,6.778,4.8Z",
    transform: "translate(-2 -2)",
    fill: "#586d70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartInactive);
export default __webpack_public_path__ + "static/media/start_inactive.4224bcc07a110730cb1301be1544fa80.svg";
export { ForwardRef as ReactComponent };